"use client"

import type { ReactNode } from "react"

import { Tab, TabGroup, TabList } from "@headlessui/react"

type SegmentedOption = string | { label: ReactNode; ariaLabel: string }

interface SegmentedProps {
  options: SegmentedOption[]
  selectedIndex?: number
  onChange?: (index: number) => void
}

export const Segmented = ({ options, selectedIndex, onChange }: SegmentedProps) => (
  <TabGroup selectedIndex={selectedIndex} onChange={onChange} as="div" className="inline-flex">
    <TabList className="bg-surface-newgray inline-flex gap-0 rounded-full p-100">
      {options.map((option, index) => {
        const isPlain = typeof option === "string"
        return (
          <Tab
            key={index}
            aria-label={isPlain ? undefined : option.ariaLabel}
            title={isPlain ? undefined : option.ariaLabel}
            className="hit-target font-display text-body-sm text-fg-subtle data-selected:bg-surface data-selected:text-fg focus-visible:ring-brand rounded-full px-350 py-200 font-semibold transition-colors focus-visible:ring-2 focus-visible:outline-none focus-visible:ring-inset data-selected:shadow-sm"
          >
            {isPlain ? option : option.label}
          </Tab>
        )
      })}
    </TabList>
  </TabGroup>
)
